// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","LeftGroup":"Footer_LeftGroup__ii5Ep","RightGroup":"Footer_RightGroup__yVuvr","SocialMedia":"Footer_SocialMedia__gZsgV","Links":"Footer_Links__RJStj"};